import axios from "axios";
import { variables } from "../variables";

const URL = "https://thingproxy.freeboard.io/fetch/https://mecqa.siged.sep.gob.mx/mec/mvc/registroIpes/validaCurp";
const states = [
    { name: "AGUASCALIENTES", code: "AS" },
    { name: "BAJA CALIFORNIA", code: "BC" },
    { name: "BAJA CALIFORNIA SUR", code: "BS" },
    { name: "CAMPECHE", code: "CC" },
    { name: "COAHUILA", code: "CL" },
    { name: "COLIMA", code: "CM" },
    { name: "CHIAPAS", code: "CS" },
    { name: "CHIHUAHUA", code: "CH" },
    { name: "DISTRITO FEDERAL", code: "DF" },
    { name: "DURANGO", code: "DG" },
    { name: "GUANAJUATO", code: "GT" },
    { name: "GUERRERO", code: "GR" },
    { name: "HIDALGO", code: "HG" },
    { name: "JALISCO", code: "JC" },
    { name: "MÉXICO", code: "MC" },
    { name: "MICHOACÁN", code: "MN" },
    { name: "MORELOS", code: "MS" },
    { name: "NAYARIT", code: "NT" },
    { name: "NUEVO LEÓN", code: "NL" },
    { name: "OAXACA", code: "OC" },
    { name: "PUEBLA", code: "PL" },
    { name: "QUERÉTARO", code: "QT" },
    { name: "QUINTANA ROO", code: "QR" },
    { name: "SAN LUIS POTOSÍ", code: "SP" },
    { name: "SINALOA", code: "SL" },
    { name: "SONORA", code: "SR" },
    { name: "TABASCO", code: "TC" },
    { name: "TAMAULIPAS", code: "TS" },
    { name: "TLAXCALA", code: "TL" },
    { name: "VERACRUZ", code: "VZ" },
    { name: "YUCATÁN", code: "YN" },
    { name: "ZACATECAS", code: "ZS" },
];

const sex = [
    { name: "HOMBRE", code: "H" },
    { name: "MUJER", code: "M" }
];

export default {
    state: {
        candidateInfo: {
            curp: "",
            urlAvatar: "",
            sexo: "",
            dia: "",
            mes: "",
            year: "",
            name: "",
            lastName: "",
            lastName2: "",
            state: ""
        }
    },
    mutations: {
        setCandidate(state, value) {
            state.candidateInfo = value;
        }

    },
    getters: {
        getCandidate(state) {
            return state.candidateInfo
        }

    },
    actions: {
        async getCurpInfoSingle(context, object){
            let data = { "curp": object.curp }
            let response = await axios.post(URL, data, {
                headers: {
                    'Accept':'*/*',
                    'Content-Type':'application/json',
                    'X-Requested-With':'XMLHttpRequest'
                }
            })
            if(response.data){
                var fecha = new Date(response.data.fechaNacimiento)
                var entidad = object.curp.substring(11, 13)
                var nombre = response.data.nombres
                var Apaterno = response.data.primerApellido
                var Amaterno = response.data.segundoApellido || "X"
                var sexo;
                var estado;
    
                sex.forEach(function (element) {
                    if (element.code == response.data.sexo) {
                        sexo = element.name
                    }
                })
    
                states.forEach(function (element) {
                    if (element.code == entidad) {
                        estado = element.name
                    }
                })
    
                var candidates = {
                    curp: object.curp,
                    urlAvatar: object.foto,
                    sexo: sexo,
                    dia: fecha.getDate(),
                    mes: fecha.getMonth() + 1,
                    year: fecha.getFullYear(),
                    name: nombre,
                    lastName: Apaterno,
                    lastName2: Amaterno,
                    state: estado!=undefined?estado:'EXTRANJERO'
                };
    

                return candidates;
            }
            else{
                return false
            }
                

        },
        async getCurpInfo(context, object) {
   
            let data = { "curp": object.curp }
            let response = await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/applications/getCurp/${object.curp}`)
            // let response = await axios.post(URL, data)
            //let response = await axios.get(`https://e7pj9mzqll.execute-api.us-west-2.amazonaws.com/dev/getCurp/${object.curp}`)
            //console.log(response.data.data)
         
            if(response.data){
            var fecha = new Date(response.data.data.fechaNacimiento)
            var entidad = object.curp.substring(11, 13)
            var nombre = response.data.data.nombres
            var Apaterno = response.data.data.primerApellido
            var Amaterno = response.data.data.segundoApellido || "X"
            var sexo;
            var estado;

            sex.forEach(function (element) {
                if (element.code == response.data.data.sexo) {
                    sexo = element.name
                }
            })

            states.forEach(function (element) {
                if (element.code == entidad) {
                    estado = element.name
                }
            })

            var candidates = {
                curp: object.curp,
                urlAvatar: object.foto,
                sexo: sexo,
                dia: fecha.getDate(),
                mes: fecha.getMonth() + 1,
                year: fecha.getFullYear(),
                name: nombre,
                lastName: Apaterno,
                lastName2: Amaterno,
                state: estado!=undefined?estado:'EXTRANJERO'
            };

            context.commit('setCandidate', candidates)
            return true;
            }else 
                return false;

        },
        async completeStep1(context, object){
            let response = await context.rootGetters.api.post(variables.serverUrl+"/api/v1/applications", object)
            return response;

        },
        async recommendationsNumber(context){
            let response = await context.rootGetters.api.get(variables.serverUrl+"/api/v1/clubs/partner-recommendations-number");
           return response

        },
        async updateTitular(context, data){
            return await context.rootGetters.api.put(`${variables.serverUrl}/api/v1/applications/update-data`, data);
        },
        async updateBeneficiaries(context, data){
            return await context.rootGetters.api.put(`${variables.serverUrl}/api/v1/applications/update-beneficiaries-data`, data);
        }


    }

}